import React from "react"

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"

const AIPlugin = ({ isGenerating }: { isGenerating: boolean }) => {
  const [editor] = useLexicalComposerContext()
  React.useEffect(() => {
    editor.setEditable(!isGenerating)
  }, [editor, isGenerating])
  return null
}

export default AIPlugin
